/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */

/**
 * Utilities for SVG calculations and creations
 */
export class SvgTools {
  /**
   * calculates absolut cartesian position polar coordinate with a given center
   *
   * @param centerX - center x component of the polar coord
   * @param centerY - center y component of the polar coord
   * @param radius - radius of the polar coord
   * @param angleInDegrees -angle of the polar coord (in degree)
   * @returns x/y-pair
   */
  static POLAR_TO_CARTESIAN(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
      x: centerX + radius * Math.cos(angleInRadians),
      y: centerY + radius * Math.sin(angleInRadians)
    };
  }
  /**
   * generates a SVG Path for arcs (with a more user friendly interface)
   *
   * @param x - center x component of the arc
   * @param y - center y component of the arc
   * @param radius - radius of the arc
   * @param startAngle - start angle of the arc
   * @param endAngle - end angle of the arc
   * @returns the svg path of the arc
   */


  static DESCRIBE_ARC(x, y, radius, startAngle, endAngle) {
    if (startAngle === endAngle) {
      return '';
    }

    const start = SvgTools.POLAR_TO_CARTESIAN(x, y, radius, endAngle);
    const end = SvgTools.POLAR_TO_CARTESIAN(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    const d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
    return d;
  }
  /**
   * creates a "data:image/svg+xml" href for svg markup (strings)
   *
   * @param svg - svg to embed
   * @returns href from this svg
   */


  static EMBED_SVG(svg) {
    let href = svg; // already a data url svg

    if (svg.startsWith('<svg')) {
      href = 'data:image/svg+xml,' + svg;
    }

    href = href.replace(/#/g, '%23'); // in chrome # not allowed in svg url

    return href;
  }
  /**
   * Removes all occurences of 'fill' attribute and adds given fill-color
   *
   * @param svg - the src-svg-string
   * @param color - the new fill color
   *
   * @returns the new svg string
   */


  static REPLACE_FILL_COLOR(svg, color) {
    if (['%3e', '>'].some(sign => svg.toLocaleLowerCase().indexOf(sign) > 0)) {
      // append fill color just before closing tag '>' or '%3E'
      svg = svg.replace(/\s*fill\s*=\s*["'].*?['"]/g, ''); // eliminate all fill attributes before putting setting a new one

      let pos = svg.indexOf('>');

      if (pos < 0) {
        pos = svg.toLocaleLowerCase().indexOf('%3e');
      }

      svg = svg.substring(0, pos) + ` fill="${color}"` + svg.substring(pos);
    }

    return svg;
  }
  /**
   * Determine necessary size of the given SVG inside a shadowroot.
   * The resulting dimensions can be passed to its viewPort in order to achieve a full-screen view of the SVG.
   *
   * @param svgEl - the svg to evaluate
   * @param styleTxt - the shadow style (make sure the svgEl is rendered in the same way as in production)
   * @returns the svg deminsions as bounding-box
   */


  static SVG_BOX(svgEl, styleTxt) {
    let bb = svgEl.getBBox();

    if (bb.width === 0) {
      // already visible? then we don't have to go the hard way
      const tempDiv = document.createElement('div');
      tempDiv.setAttribute('style', 'position:absolute; visibility: hidden');
      const shadow = tempDiv.attachShadow({
        mode: 'open'
      });
      const style = document.createElement('style');
      style.textContent = styleTxt;
      shadow.appendChild(style);
      const tempSvgEl = svgEl.cloneNode(true);
      shadow.appendChild(tempSvgEl);
      document.body.appendChild(tempDiv);
      bb = tempSvgEl.getBBox();
      tempDiv.remove();
    }

    return bb;
  }

}
